import React from 'react';

import type { SwitchToggleChangeEventHandler } from 'js/src/components/common/ui/SwitchToggle';
import SwitchToggle from 'js/src/components/common/ui/SwitchToggle';
import Tooltip, { Placement } from 'js/src/components/common/ui/Tooltip';

interface SystemAudioToggleProps {
    checked: boolean;
    onChange: SwitchToggleChangeEventHandler;
}

const SYSTEM_AUDIO_TOOLTIP =
    "To include system audio, be sure to toggle on here AND inside of the browser's " +
    'screen share dialog';

const SystemAudioToggleButton = ({ checked, onChange }: SystemAudioToggleProps) => {
    return (
        <div className={'d-flex align-items-center'}>
            <SwitchToggle checked={checked} onChange={onChange} />
            <span className="font-l5 font-l5--small ms-l5-8">Capture system audio</span>
            <Tooltip title={SYSTEM_AUDIO_TOOLTIP} placement={Placement.TOP}>
                <span className="material-symbols-outlined icon-l5 icon-l5--small color-grey-600 ms-l5-4">
                    info
                </span>
            </Tooltip>
        </div>
    );
};

export default React.memo(SystemAudioToggleButton);
